import React, {useState} from "react";
import {useTranslate} from "@tolgee/react";
import Alert from "view/components/Alert";
import FlexBox from "view/components/Layout/FlexBox";
import {Typography, useTheme} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {MULTIPLE_ORDER_ALERT} from "view/apps/Exhibitor/pages/Cart/components/Payment/components/Card/OrdersList/constants";

const OrderAlert = () => {
  const theme = useTheme();
  const {t} = useTranslate();
  const [isMessageAcknowledged, setIsMessageAcknowledged] = useState(false);

  if (isMessageAcknowledged) {
    return null;
  }

  return (
    <Alert severity="info" fullWidth>
      <FlexBox gap={3} alignCenter justifyBetween>
        <Typography
          variant="h4"
          style={{color: theme.palette.contrastText.main, lineHeight: 1.5}}
        >
          {t(MULTIPLE_ORDER_ALERT.message)}
        </Typography>
        <Button
          variant="text"
          color="primary"
          onClick={() => setIsMessageAcknowledged(true)}
        >
          {t(MULTIPLE_ORDER_ALERT.buttonText)}
        </Button>
      </FlexBox>
    </Alert>
  );
};

export default OrderAlert;
